<!-- Diálogo "Criar novo Item" (cadastro rápido de mercadoria).

     A classe `icr-dialog` no styleClass é a CONTENÇÃO deste componente: o
     `appendTo="body"` tira o diálogo de dentro do host, então `:host ::ng-deep`
     não alcança nada e a única forma de conter os estilos é uma classe
     exclusiva. `dialog-wave-redesign` fica junto só pelo visual herdado do
     global — as regras de layout deste diálogo estão TODAS sob `.icr-dialog`
     no SCSS. Ver o comentário do arquivo .scss (armadilha do `!important`). -->
<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  appendTo="body"
  styleClass="dialog-wave-redesign icr-dialog"
  [style]="{ width: '550px' }"
  [breakpoints]="{ '768px': '95vw' }"
  (onHide)="fechar()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-plus" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'produto-selecionar.dialog.criar_item_titulo' | translate }}</h2>
        <p>{{ 'produto-selecionar.dialog.criar_item_descricao' | translate }}</p>
      </div>
    </div>
    <button pButton icon="pi pi-times" class="p-button-rounded p-button-text icr-btn-fechar"
      [disabled]="salvando"
      [attr.aria-label]="'produto-selecionar.buttons.cancelar' | translate"
      (click)="fechar()"></button>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">

    <div class="icr-form">

      <!-- Nome do Produto (obrigatório) -->
      <div class="icr-field">
        <label class="icr-label" for="icrNome">
          {{ 'produto-selecionar.labels.nome_produto' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input id="icrNome" pInputText class="w-full" [(ngModel)]="form.nome"
          [placeholder]="'produto-selecionar.placeholders.nome_produto' | translate" />
      </div>

      <!-- Código de Barras (opcional) -->
      <div class="icr-field">
        <label class="icr-label" for="icrBarras">
          {{ 'produto-selecionar.labels.codigo_barras' | translate }}
        </label>
        <input id="icrBarras" pInputText class="w-full" [(ngModel)]="form.barras"
          [placeholder]="'produto-selecionar.placeholders.codigo_barras' | translate" />
      </div>

      <!-- Categoria (obrigatória) e Subcategoria (opcional) -->
      <div class="icr-row">
        <div class="icr-field flex-1">
          <label class="icr-label">
            {{ 'produto-selecionar.labels.grupo' | translate }}
            <span class="text-red-500">*</span>
          </label>
          <app-select-grupo [(ngModel)]="form.grupo_id" [returnType]="'id'"
            [showAddButton]="permGrupo"></app-select-grupo>
        </div>
        <div class="icr-field flex-1">
          <label class="icr-label">
            {{ 'produto-selecionar.labels.sub_grupo' | translate }}
          </label>
          <app-select-subgrupo [(ngModel)]="form.subGrupo_id" [returnType]="'id'"
            [grupoId]="form.grupo_id" [showAddButton]="permSubgrupo"></app-select-subgrupo>
        </div>
      </div>

      <!-- Marca (opcional) e Unidade de Medida (obrigatória) -->
      <div class="icr-row">
        <div class="icr-field flex-1">
          <label class="icr-label">
            {{ 'produto-selecionar.labels.marca' | translate }}
          </label>
          <app-select-marca [(ngModel)]="form.marca_id" [returnType]="'id'"
            [showAddButton]="permMarca"></app-select-marca>
        </div>
        <div class="icr-field flex-1">
          <label class="icr-label">
            {{ 'produto-selecionar.labels.unidade_medida' | translate }}
            <span class="text-red-500">*</span>
          </label>
          <app-select-unidade-medida [(ngModel)]="form.unidadeMedida" [returnType]="'object'"
            [showAddButton]="permUnidade"
            (ngModelChange)="onUnidadeMedidaChange($event)"></app-select-unidade-medida>
        </div>
      </div>

      <!-- Estoque Mínimo (opcional) -->
      <div class="icr-field">
        <label class="icr-label">
          {{ 'produto-selecionar.labels.estoque_minimo' | translate }}
        </label>
        <app-input-quantidade [(ngModel)]="form.estoqueMinimo"
          [casasDecimais]="casasDecimaisEstoque"
          [style]="{ width: '100%' }"></app-input-quantidade>
      </div>

      <!-- Imagem do Produto (opcional) -->
      <div class="icr-field">
        <label class="icr-label">
          {{ 'produto-selecionar.labels.imagem_produto' | translate }}
        </label>
        <div class="icr-imagem-upload">
          <div *ngIf="form.imagem" class="icr-imagem-preview">
            <img [src]="form.imagem" alt="Preview" class="icr-imagem-thumb" />
            <button pButton type="button" icon="pi pi-times"
              class="p-button-rounded p-button-danger p-button-text p-button-sm"
              (click)="removerImagem()"></button>
          </div>
          <div *ngIf="!form.imagem" class="icr-imagem-input">
            <label class="icr-imagem-btn" for="icrImagemInput">
              <i class="pi pi-camera"></i>
              <span>{{ 'produto-selecionar.placeholders.selecione_imagem' | translate }}</span>
            </label>
            <input id="icrImagemInput" type="file" accept="image/*"
              (change)="onImagemSelecionada($event)" style="display: none" />
          </div>
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="flex justify-content-end gap-2 pt-3">
      <button pButton
        [label]="'produto-selecionar.buttons.cancelar' | translate"
        class="p-button-text p-button-secondary"
        [disabled]="salvando"
        (click)="fechar()"></button>
      <button pButton icon="pi pi-check"
        [label]="'produto-selecionar.buttons.salvar' | translate"
        class="p-button-success"
        [loading]="salvando"
        [disabled]="salvando"
        (click)="salvar()"></button>
    </div>

  </div>
</p-dialog>
